/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const App = styled.div`
  min-height: 80px;
  width: 100%;
  //display: flex;
  //align-items: flex-start;
  display: grid;
  grid-template-columns: 240px 150px 120px 100px 140px;
`;

export const Container = styled.div`
  margin-top: ${({ isFirstElement }) => (isFirstElement ? '24px' : '8px')};
  display: flex;
  flex-direction: column;
  background: ${({ isBudgetPerGeo }) => (isBudgetPerGeo ? Palette.PrimaryGray._000 : 'white')};
  border-radius: 4px;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 0px 1px 2px 0px rgba(30, 50, 70, 0.06), 0px 1px 3px 0px rgba(30, 50, 70, 0.1);
  width: calc(100% - 42px);
`;

export const NameWrap = styled.div`
  width: 240px;
  padding: 12px 0 12px 16px;
  gap: 16px;
  display: flex;
  flex-shrink: 0;

  img {
    border-radius: 4px;
  }
`;

export const IdsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  width: 110%;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
`;

export const BudgetWrap = styled.div`
  display: grid;
  grid-template-columns: 88px 1fr;
  width: 240px;
  column-gap: 16px;
  row-gap: 18px;
  padding: 22px 16px;
`;

export const RadioButtonsWrap = styled.div`
  display: flex;
  grid-column: 2 / 6;
  padding: 16px 22px 22px 16px;

  & button {
    flex-grow: 1;
  }
`;

export const Label = styled.label`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  user-select: none;
  cursor: pointer;
`;

export const PbaName = styled('div')`
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  margin-top: 2px;
`;

export const PackageName = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ActiveCampaigns = styled.div`
  padding: 34px 16px 0 16px;
  width: 120px;
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  user-select: none;
`;

export const Countries = styled.div`
  padding: 34px 16px 0 16px;
  width: 150px;
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  user-select: none;
`;

export const AppData = styled.div`
  overflow: hidden;
  flex-grow: 1;
`;

export const MessageBlock = styled.div`
  padding: 0 8px 8px 8px;

  [type='warning'] {
    background-color: ${Palette.Orange._000} !important;
  }
`;

export const ErrorMsg = styled.p`
  color: ${Palette.Red._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
`;
